import React, {useCallback, useMemo} from 'react';

import {CartSuccessModal, CartSuccessModalProps} from '@udemy-v2/react-cart-success-modal';
import {withPriceEventTrackingContext} from '@/features/course-landing-page/events/with-price-event-tracking-context';
import {useClpVoucherContext} from '@/features/course-landing-page/context/voucher-context.react-component';
import {useFeatures} from '@udemy-v2/react-experimentation';
import {publishEvent} from '@udemy-v2/event-tracking';
import {ExperimentImpressionEvent} from '@udemy-v2/react-experimentation';

const InternalCartSuccessModal = (props: CartSuccessModalProps) => {
    const {certificationVoucher, certificationTopicId, bundledCertificationCourses} =
        useClpVoucherContext();

    const {featureVariantAssignments: features} = useFeatures(['cert_bundles_in_clp_fbt_modal']);
    const showCertBundleFeature = useMemo(
        () => features.get('cert_bundles_in_clp_fbt_modal'),
        [features],
    );
    const certificationData = useMemo(() => {
        const fbtModalCertBundleVariant =
            showCertBundleFeature?.configuration?.fbtModalCertBundleVariant ?? 'HIDDEN';

        if (fbtModalCertBundleVariant === 'HIDDEN') {
            return undefined;
        }

        if (certificationVoucher) {
            return {
                certificationTopicId: certificationTopicId ?? undefined,
                bundledCertificationCourses,
                certificationVoucher,
            };
        } else {
            return undefined;
        }
    }, [
        showCertBundleFeature,
        bundledCertificationCourses,
        certificationTopicId,
        certificationVoucher,
    ]);
    const emitVoucherExperimentImpression = useCallback(() => {
        if (certificationVoucher) {
            publishEvent(
                new ExperimentImpressionEvent({
                    experimentIds: showCertBundleFeature?.experimentIds ?? [],
                    isLocalDefaultShown: showCertBundleFeature?.isLocalDefault ?? false,
                }),
            );
        }
    }, [
        certificationVoucher,
        showCertBundleFeature?.experimentIds,
        showCertBundleFeature?.isLocalDefault,
    ]);

    return (
        <CartSuccessModal
            {...props}
            onOpen={emitVoucherExperimentImpression}
            certificationData={certificationData}
            options={{
                aLaCarte:
                    showCertBundleFeature?.configuration?.fbtModalCertBundleVariant === 'ALACARTE',
            }}
        />
    );
};

/**
 * CartSuccessModal wrapped with price event tracking context.
 * This ensures all pricing events triggered within the modal have the 'cartSuccessModal' context.
 */
export const ClpCartSuccessModal = withPriceEventTrackingContext(InternalCartSuccessModal, {
    context: 'cartSuccessModal',
});
